import images from "./images";

const cricketTeams = [
  {
    id: 1,
    name: 'united falcon',
    logo: images.unitedFalcon,
    players: [
      { id: 1, name: 'James Anderson', role: 'Right-Hand Batsman' },
      { id: 2, name: 'John Smith', role: 'Right-Hand Batsman' },
      { id: 3, name: 'Robert Johnson', role: 'Right-Hand Batsman' },
      { id: 4, name: 'Michael Davis', role: 'Right-Hand Batsman' },
      { id: 5, name: 'William Brown', role: 'Right-Hand Batsman' },
      { id: 6, name: 'David Martinez', role: 'Left-Hand Batsman, Left-Arm leg spin bowler' },
      { id: 7, name: 'Joseph Taylor', role: 'Right-Hand Batsman, Left-Arm leg spin bowler' },
      { id: 8, name: 'Charles Wilson', role: 'Right-Arm medium fast bowler' },
      { id: 9, name: 'Thomas Thompson', role: 'Right-Arm fast bowler' },
      { id: 10, name: 'Daniel Garcia', role: 'Right-Arm medium fast bowler' },
      { id: 11, name: 'Matthew Davis', role: 'Right-Arm fast bowler' },
      { id: 12, name: 'Samuel Clark', role: 'Left-Hand Batsman' },
      { id: 13, name: 'Andrew Lewis', role: 'Right-Hand Batsman, Right-Arm off spin bowler' },
      { id: 14, name: 'Patrick Walker', role: 'Right-Hand Batsman, Right-Arm medium bowler' },
      { id: 15, name: 'Anthony Hall', role: 'Left-Hand Batsman, Left-Arm orthodox spin bowler' },
      { id: 16, name: 'Brian Young', role: 'Right-Arm fast bowler' },
      { id: 17, name: 'Kevin King', role: 'Right-Hand Batsman, Wicket-Keeper' },
      { id: 18, name: 'Ethan Scott', role: 'Left-Hand Batsman, Left-Arm medium bowler' },
      { id: 19, name: 'Ryan Adams', role: 'Right-Arm medium fast bowler' },
      { id: 20, name: 'Lucas Baker', role: 'All-Rounder, Right-Hand Batsman, Right-Arm off spin bowler' }
    ]
  },
  {
    id: 2,
    name: 'wolf club',
    logo: images.wolfClub,
    players: [
      { id: 1, name: 'Liam Carter', role: 'Right-Hand Batsman' },
      { id: 2, name: 'Noah Mitchell', role: 'Right-Hand Batsman' },
      { id: 3, name: 'Mason Roberts', role: 'Right-Hand Batsman' },
      { id: 4, name: 'Ethan Wright', role: 'Right-Hand Batsman' },
      { id: 5, name: 'Logan Hill', role: 'Right-Hand Batsman' },
      { id: 6, name: 'Alexander Moore', role: 'Left-Hand Batsman, Left-Arm leg spin bowler' },
      { id: 7, name: 'Jacob Scott', role: 'Right-Hand Batsman, Left-Arm leg spin bowler' },
      { id: 8, name: 'Michael Lewis', role: 'Right-Arm medium fast bowler' },
      { id: 9, name: 'Daniel King', role: 'Right-Arm fast bowler' },
      { id: 10, name: 'Matthew Walker', role: 'Right-Arm medium fast bowler' },
      { id: 11, name: 'Joshua Young', role: 'Right-Arm fast bowler' },
      { id: 12, name: 'Christopher Allen', role: 'Left-Hand Batsman' },
      { id: 13, name: 'Andrew Adams', role: 'Right-Hand Batsman, Right-Arm off spin bowler' },
      { id: 14, name: 'Ryan Baker', role: 'Right-Hand Batsman, Right-Arm medium bowler' },
      { id: 15, name: 'Anthony Nelson', role: 'Left-Hand Batsman, Left-Arm orthodox spin bowler' },
      { id: 16, name: 'Samuel Harris', role: 'Right-Arm fast bowler' },
      { id: 17, name: 'David Carter', role: 'Right-Hand Batsman, Wicket-Keeper' },
      { id: 18, name: 'Brandon Scott', role: 'Left-Hand Batsman, Left-Arm medium bowler' },
      { id: 19, name: 'Christopher Adams', role: 'Right-Arm medium fast bowler' },
      { id: 20, name: 'Lucas Evans', role: 'All-Rounder, Right-Hand Batsman, Right-Arm off spin bowler' }
    ]
  },
  {
    id: 3,
    name: 'tigers club',
    logo: images.tigersClub,
    players: [
      { id: 1, name: 'Oliver Johnson', role: 'Right-Hand Batsman' },
      { id: 2, name: 'Elijah Williams', role: 'Right-Hand Batsman' },
      { id: 3, name: 'James Brown', role: 'Right-Hand Batsman' },
      { id: 4, name: 'Benjamin Jones', role: 'Right-Hand Batsman' },
      { id: 5, name: 'Lucas Miller', role: 'Right-Hand Batsman' },
      { id: 6, name: 'Mason Wilson', role: 'Left-Hand Batsman, Left-Arm leg spin bowler' },
      { id: 7, name: 'Ethan Moore', role: 'Right-Hand Batsman, Left-Arm leg spin bowler' },
      { id: 8, name: 'Alexander Taylor', role: 'Right-Arm medium fast bowler' },
      { id: 9, name: 'Jacob Thomas', role: 'Right-Arm fast bowler' },
      { id: 10, name: 'Michael White', role: 'Right-Arm medium fast bowler' },
      { id: 11, name: 'Daniel Harris', role: 'Right-Arm fast bowler' },
      { id: 12, name: 'Matthew Martin', role: 'Left-Hand Batsman' },
      { id: 13, name: 'Ryan Thompson', role: 'Right-Hand Batsman, Right-Arm off spin bowler' },
      { id: 14, name: 'Joseph Anderson', role: 'Right-Hand Batsman, Right-Arm medium bowler' },
      { id: 15, name: 'Christopher Hall', role: 'Left-Hand Batsman, Left-Arm orthodox spin bowler' },
      { id: 16, name: 'Anthony Young', role: 'Right-Arm fast bowler' },
      { id: 17, name: 'William King', role: 'Right-Hand Batsman, Wicket-Keeper' },
      { id: 18, name: 'Brandon Scott', role: 'Left-Hand Batsman, Left-Arm medium bowler' },
      { id: 19, name: 'David Adams', role: 'Right-Arm medium fast bowler' },
      { id: 20, name: 'Lucas Walker', role: 'All-Rounder, Right-Hand Batsman, Right-Arm off spin bowler' }
    ]
  },
  {
    id: 4,
    name: 'eagle club',
    logo: images.eagleClub,
    players: [
      { id: 1, name: 'Ethan Parker', role: 'Right-Hand Batsman' },
      { id: 2, name: 'Logan Roberts', role: 'Right-Hand Batsman' },
      { id: 3, name: 'Mason Lewis', role: 'Right-Hand Batsman' },
      { id: 4, name: 'Aiden Johnson', role: 'Right-Hand Batsman' },
      { id: 5, name: 'Lucas Hall', role: 'Right-Hand Batsman' },
      { id: 6, name: 'Oliver Scott', role: 'Left-Hand Batsman, Left-Arm leg spin bowler' },
      { id: 7, name: 'Liam White', role: 'Right-Hand Batsman, Left-Arm leg spin bowler' },
      { id: 8, name: 'Benjamin Clark', role: 'Right-Arm medium fast bowler' },
      { id: 9, name: 'William Lewis', role: 'Right-Arm fast bowler' },
      { id: 10, name: 'James Walker', role: 'Right-Arm medium fast bowler' },
      { id: 11, name: 'Alexander Harris', role: 'Right-Arm fast bowler' },
      { id: 12, name: 'Daniel Adams', role: 'Left-Hand Batsman' },
      { id: 13, name: 'Ryan Brown', role: 'Right-Hand Batsman, Right-Arm off spin bowler' },
      { id: 14, name: 'Michael Thomas', role: 'Right-Hand Batsman, Right-Arm medium bowler' },
      { id: 15, name: 'Christopher Martinez', role: 'Left-Hand Batsman, Left-Arm orthodox spin bowler' },
      { id: 16, name: 'Joshua Young', role: 'Right-Arm fast bowler' },
      { id: 17, name: 'David King', role: 'Right-Hand Batsman, Wicket-Keeper' },
      { id: 18, name: 'Brandon Scott', role: 'Left-Hand Batsman, Left-Arm medium bowler' },
      { id: 19, name: 'Nathan Adams', role: 'Right-Arm medium fast bowler' },
      { id: 20, name: 'Lucas Evans', role: 'All-Rounder, Right-Hand Batsman, Right-Arm off spin bowler' }
    ]
  },
  {
    id: 5,
    name: 'lions club',
    logo: images.lionsClub,
    players: [
      { id: 1, name: 'Logan Carter', role: 'Right-Hand Batsman' },
      { id: 2, name: 'Mason Lewis', role: 'Right-Hand Batsman' },
      { id: 3, name: 'Ethan Mitchell', role: 'Right-Hand Batsman' },
      { id: 4, name: 'Oliver Thompson', role: 'Right-Hand Batsman' },
      { id: 5, name: 'Lucas Roberts', role: 'Right-Hand Batsman' },
      { id: 6, name: 'Benjamin Scott', role: 'Left-Hand Batsman, Left-Arm leg spin bowler' },
      { id: 7, name: 'Alexander Johnson', role: 'Right-Hand Batsman, Left-Arm leg spin bowler' },
      { id: 8, name: 'Daniel Walker', role: 'Right-Arm medium fast bowler' },
      { id: 9, name: 'Matthew White', role: 'Right-Arm fast bowler' },
      { id: 10, name: 'Joshua Brown', role: 'Right-Arm medium fast bowler' },
      { id: 11, name: 'Ryan Harris', role: 'Right-Arm fast bowler' },
      { id: 12, name: 'Christopher Hall', role: 'Left-Hand Batsman' },
      { id: 13, name: 'Anthony Lewis', role: 'Right-Hand Batsman, Right-Arm off spin bowler' },
      { id: 14, name: 'David Walker', role: 'Right-Hand Batsman, Right-Arm medium bowler' },
      { id: 15, name: 'Nathan Adams', role: 'Left-Hand Batsman, Left-Arm orthodox spin bowler' },
      { id: 16, name: 'Samuel Scott', role: 'Right-Arm fast bowler' },
      { id: 17, name: 'Kevin Johnson', role: 'Right-Hand Batsman, Wicket-Keeper' },
      { id: 18, name: 'Brandon Carter', role: 'Left-Hand Batsman, Left-Arm medium bowler' },
      { id: 19, name: 'Ryan Lewis', role: 'Right-Arm medium fast bowler' },
      { id: 20, name: 'Lucas Evans', role: 'All-Rounder, Right-Hand Batsman, Right-Arm off spin bowler' }
    ]
  },
  {
    id: 6,
    name: 'hawk club',
    logo: images.hawkClub,
    players: [
      { id: 1, name: 'Evan Carter', role: 'Right-Hand Batsman' },
      { id: 2, name: 'Liam Thompson', role: 'Right-Hand Batsman' },
      { id: 3, name: 'Noah Wilson', role: 'Right-Hand Batsman' },
      { id: 4, name: 'Mason White', role: 'Right-Hand Batsman' },
      { id: 5, name: 'Oliver Brown', role: 'Right-Hand Batsman' },
      { id: 6, name: 'Alexander Martin', role: 'Left-Hand Batsman, Left-Arm leg spin bowler' },
      { id: 7, name: 'Jacob Scott', role: 'Right-Hand Batsman, Left-Arm leg spin bowler' },
      { id: 8, name: 'Daniel Lewis', role: 'Right-Arm medium fast bowler' },
      { id: 9, name: 'Matthew Hall', role: 'Right-Arm fast bowler' },
      { id: 10, name: 'Joshua Adams', role: 'Right-Arm medium fast bowler' },
      { id: 11, name: 'Ryan Walker', role: 'Right-Arm fast bowler' },
      { id: 12, name: 'Christopher Young', role: 'Left-Hand Batsman' },
      { id: 13, name: 'Andrew Baker', role: 'Right-Hand Batsman, Right-Arm off spin bowler' },
      { id: 14, name: 'Anthony King', role: 'Right-Hand Batsman, Right-Arm medium bowler' },
      { id: 15, name: 'Samuel Hall', role: 'Left-Hand Batsman, Left-Arm orthodox spin bowler' },
      { id: 16, name: 'David Harris', role: 'Right-Arm fast bowler' },
      { id: 17, name: 'Kevin Lewis', role: 'Right-Hand Batsman, Wicket-Keeper' },
      { id: 18, name: 'Brandon Evans', role: 'Left-Hand Batsman, Left-Arm medium bowler' },
      { id: 19, name: 'Ethan Carter', role: 'Right-Arm medium fast bowler' },
      { id: 20, name: 'Lucas Thompson', role: 'All-Rounder, Right-Hand Batsman, Right-Arm off spin bowler' }
    ]
  },
]

export default cricketTeams;